function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * Encuentra la opción de catálogo más cercana a un texto escrito a mano,
 * para autoseleccionarla cuando el campo pierde el foco sin una elección
 * explícita (p. ej. escribir "agr" y hacer click fuera del input de banco).
 *
 * Orden de prioridad:
 * 1) Coincidencia exacta (ignorando mayúsculas/acentos de caja).
 * 2) Coincidencia por inicio de PALABRA completa dentro del nombre — no solo
 *    el inicio del string entero, porque catálogos como el de bancos
 *    comparten un prefijo común ("Banco ...") que dejaría ese criterio casi
 *    sin uso. Entre varias, gana el nombre más corto (más específico).
 * 3) Coincidencia por substring en cualquier posición, mismo criterio de
 *    desempate.
 * Si no hay ninguna coincidencia, devuelve null (el llamador decide si
 * limpiar el campo o mantener el valor previo).
 */
export function closestTextMatch<T>(term: string, items: T[], getName: (item: T) => string): T | null {
  const needle = term.trim().toLowerCase();
  if (!needle) return null;

  const exact = items.find(item => getName(item).trim().toLowerCase() === needle);
  if (exact) return exact;

  const byShortestName = (a: T, b: T) => getName(a).length - getName(b).length;

  const wordBoundaryRe = new RegExp(`\\b${escapeRegExp(needle)}`, 'i');
  const wordStart = items.filter(item => wordBoundaryRe.test(getName(item))).sort(byShortestName);
  if (wordStart.length) return wordStart[0];

  const contains = items.filter(item => getName(item).toLowerCase().includes(needle)).sort(byShortestName);
  return contains[0] || null;
}
